import {patchState, signalStore, withComputed, withMethods, withProps, withState} from '@ngrx/signals';
import {removeAllEntities, removeEntity, setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {WaterPoint} from 'src/app/infrastructure/moovement-api/models/asset';
import {DeviceAssociationStore} from 'src/app/domain/devices/device-association.store';
import {computed, inject} from '@angular/core';
import {Samples} from 'src/app/infrastructure/moovement-api/models/samples';

const initialState = {
  loadingEntities: true,
  loadingSamples: true,
  assetSamples: new Map<WaterPoint, Samples.AssetSample<number>[]>()
};

export const WaterPointsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<WaterPoint>(),
  withProps(() => ({
    deviceAssociationStore: inject(DeviceAssociationStore)
  })),
  withComputed(({loadingEntities, loadingSamples}) => ({
    loading: computed(() => {
      return loadingEntities() || loadingSamples();
    })
  })),
  withMethods((store) => ({
    setAllEntities(waterPoints: WaterPoint[]) {
      patchState(store, setAllEntities(waterPoints), {loadingEntities: false});
    },
    setEntity(waterPoint: WaterPoint) {
      patchState(store, setEntity(waterPoint))
    },
    removeEntity(id: string) {
      patchState(store, removeEntity(id))
    },
    setAssetSamples(assetSamples: Map<WaterPoint, Samples.AssetSample<number>[]>) {
      patchState(store, {assetSamples, loadingSamples: false})
    },
    reset() {
      patchState(store, removeAllEntities(), initialState);
    }
  }))
);
